<ng-container *ngIf="currentOffer$ | async as details">
  <div>
    <h1 class="pr-large-y font-heading-3 ms-clear bold-type nordic-blue-900-text">
      {{ 'ticketSelection.reviewFlights' | finLocalization }}
    </h1>
    <fin-flight-card
      [flightOrBound]="details.bounds[0]"
      [title]="'bookingSummary.departure' | finLocalization"
      [locations]="details.locations"
      [passengers]="details.passengers"
      (viewDetails)="showTicketSummaryModal(BoundType.outbound)"
      (modifyClicked)="activateSelectionPhase(SelectionPhase.OUTBOUND)"
    ></fin-flight-card>

    <fin-flight-card
      data-test-inbound
      *ngIf="(isOneWay$ | async) === false"
      class="block pr-xsmall-t"
      [flightOrBound]="details.bounds[1]"
      [locations]="details.locations"
      [passengers]="details.passengers"
      [title]="'bookingSummary.return' | finLocalization"
      (modifyClicked)="activateSelectionPhase(SelectionPhase.INBOUND)"
      (viewDetails)="showTicketSummaryModal(BoundType.inbound)"
    ></fin-flight-card>
  </div>

  <fcom-modal
    *ngIf="(ticketSummaryModal.boundType === BoundType.outbound ? details.bounds[0] : details.bounds[1]) !== undefined"
    class="ticket-summary-modal"
    [title]="'ticketSelection.flightsAndBenefits.title' | finLocalization"
    [buttons]="ModalButtons.DONE"
    [open]="ticketSummaryModal.open"
    (close)="closeModals()"
  >
    <fcom-tabs
      [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
      [nextButtonAriaLabel]="'carousel.next' | finLocalization"
      [theme]="TabTheme.IN_MODAL"
    >
      <fcom-tab [title]="'fareFamilyDetails.title' | finLocalization">
        <fin-fare-family-details
          class="block pr-medium"
          [fareFamilies]="[
            ticketSummaryModal.boundType === BoundType.outbound
              ? details.benefits[details.bounds[0].fareFamilyCode]
              : details.benefits[details.bounds[1].fareFamilyCode]
          ]"
        >
        </fin-fare-family-details>
      </fcom-tab>
      <fcom-tab [title]="'itinerary.title' | finLocalization">
        <fin-itinerary-timeline
          class="block pr-medium"
          [locations]="details.locations"
          [bound]="ticketSummaryModal.boundType === BoundType.outbound ? details.bounds[0] : details.bounds[1]"
          [boundType]="ticketSummaryModal.boundType"
          [isBookingFlow]="true"
        ></fin-itinerary-timeline>
      </fcom-tab>
    </fcom-tabs>
  </fcom-modal>
</ng-container>
